export default function (state, value) {
    state.page = value > 0 ? value : 1;
}